<template>
    <v-card :loading="loading" mx-4 min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-tabs
            v-model="tab"
            background-color="primary"
            dark
        >
            <v-tab key="general">
                Informatii generale
            </v-tab>
            <v-tab v-if="!_.isNil(form.id)" key="file">
                Fisa vehiculului
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item key="general">
                <v-card class="px-4 py-4" flat>
                    <v-autocomplete
                        v-model="form.customer_id"
                        :items="customers"
                        item-value="id"
                        item-text="name"
                        v-validate="'required'"
                        :error-messages="errorMessages('customer_id')"
                        :class="{ 'error--text': hasErrors('customer_id') }"
                        class="primary--text"
                        name="customer_id"
                        label="Client / Proprietar"
                        data-vv-as="Client / Proprietar"
                        data-vv-name="customer_id"
                    />
                    <v-text-field
                        v-model="form.brand"
                        v-validate="'required'"
                        :error-messages="errorMessages('brand')"
                        :class="{ 'error--text': hasErrors('brand') }"
                        class="primary--text"
                        name="brand"
                        label="Marca"
                        data-vv-as="Marca"
                        data-vv-name="brand"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.model"
                        v-validate="'required'"
                        :error-messages="errorMessages('model')"
                        :class="{ 'error--text': hasErrors('model') }"
                        class="primary--text"
                        name="model"
                        label="Model"
                        data-vv-as="Model"
                        data-vv-name="model"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.chassis"
                        :error-messages="errorMessages('chassis')"
                        :class="{ 'error--text': hasErrors('chassis') }"
                        class="primary--text"
                        name="chassis"
                        label="Serie sasiu"
                        data-vv-as="Serie sasiu"
                        data-vv-name="chassis"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.engine"
                        :error-messages="errorMessages('engine')"
                        :class="{ 'error--text': hasErrors('engine') }"
                        class="primary--text"
                        name="engine"
                        label="Serie motor"
                        data-vv-as="Serie motor"
                        data-vv-name="engine"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.vehicle_plate"
                        :error-messages="errorMessages('vehicle_plate')"
                        :class="{ 'error--text': hasErrors('vehicle_plate') }"
                        class="primary--text"
                        name="vehicle_plate"
                        label="Numar inregistrare/inmatriculare"
                        data-vv-as="Numar inregistrare/inmatriculare"
                        data-vv-name="vehicle_plate"
                        counter="255"
                    />
                    <v-text-field
                        type="number"
                        v-model="form.data.year"
                        :error-messages="errorMessages('year')"
                        :class="{ 'error--text': hasErrors('year') }"
                        class="primary--text"
                        name="year"
                        label="An fabricatie"
                        data-vv-as="An fabricatie"
                        data-vv-name="year"
                        counter="255"
                    />
                    <v-date-field
                        v-model="form.data.initial_inspection"
                        :error-messages="errorMessages('data.initial_inspection')"
                        :class="{ 'error--text': hasErrors('data.initial_inspection') }"
                        class="primary--text"
                        name="data.initial_inspection"
                        label="Inspectie tehnica initiala"
                        data-vv-as="Inspectie tehnica initiala"
                        data-vv-name="data.initial_inspection"
                        inputmask-placeholder="99-99-9999"
                        placeholder="zz-ll-aaaa"
                    />
                    <v-textarea
                        v-model="form.data.remarks"
                        :error-messages="errorMessages('data.remarks')"
                        :class="{ 'error--text': hasErrors('data.remarks') }"
                        class="primary--text"
                        name="data.remarks"
                        label="Observatii"
                        data-vv-as="Observatii"
                        data-vv-name="data.remarks"
                    />

                    <v-btn
                        :loading="form.busy"
                        :disabled="errors.any() || form.busy"
                        block
                        color="success"
                        @click="submit()"
                    >
                        Salveaza
                        <v-icon right>
                            save
                        </v-icon>
                    </v-btn>
                </v-card>
            </v-tab-item>

            <v-tab-item v-if="!_.isNil(form.id)" key="file">
                <offers-component :vehicle-id="form.id"></offers-component>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
    import OffersComponent from 'Components/vehicles/OffersComponent'
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";

    export default {
        mixins: [validationError],
        components: {
            OffersComponent
        },
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            customers: [],
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                customer_id: null,
                brand: null,
                model: null,
                chassis: null,
                engine: null,
                vehicle_plate: null,
                data: {
                    remarks: null,
                    year: null,
                    initial_inspection: null
                },
            }),
        }),
        async mounted() {
            const {meta, data} = await this.$db.Customer
                .select('id', 'name')
                .limit(10000)
                .get()
            this.customers = data
            if(this.id) {
                await this.loadResource()
            }
        },
        methods: {
            async loadResource() {
                let self = this;
                this.loading = true;

                let { data } = await this.$db.Vehicle.find(this.id)
                if (!this._.isNil(this._.get(data, 'data.initial_inspection'))) {
                    data.data.initial_inspection = this.$moment(data.data.initial_inspection).format('DD-MM-YYYY')
                }
                self.form = new Form(data)
                this.loading = false
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var customer = new this.$db.Customer({id: self.form.customer_id})

                if (!this._.isNil(this._.get(self.form, 'data.initial_inspection'))) {
                    self.form.data.initial_inspection = this.$moment(self.form.data.initial_inspection, 'DD-MM-YYYY').format('YYYY-MM-DD')
                }
                var model = new this.$db.Vehicle(self.form).for(customer);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        this.loadResource()
                        self.$nextTick(() => self.$router.push({name: "vehicles-index"}));
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                    self.form.busy = false;
                });
            }
        }
    };
</script>
